<template lang="pug">
div(
    :style="style"
    class="tl-space"
)
</template>

<script setup>
import { computed, inject } from 'vue'
import { getInjects } from '@/components/$tl/utils/injects'
import { useBreakpoints } from '@/composables/ui/useBreakpoints'

const bp = useBreakpoints()
const mobile = computed(() => bp.tablet?.value)
const phone = computed(() => bp.phone?.value)

const props = defineProps({
    vertical: Boolean,
    page: Boolean,
    large: Boolean,
    small: Boolean,
    xsmall: Boolean,
})

const injects = getInjects(props, inject)

const vertical = computed(() => props.vertical ?? injects.vertical?.value)
const page = computed(() => props.page ?? injects.page?.value)
const large = computed(() => props.large ?? injects.large?.value)
const small = computed(() => props.small ?? injects.small?.value)
const xsmall = computed(() => props.xsmall ?? injects.xsmall?.value)

const sizes = {
    page: ['250px', '150px', '100px'],
    large: ['100px', '70px', '50px'],
    default: ['50px', '35px', '25px'],
    small: ['25px', '20px', '15px'],
    xsmall: ['10px', '7px', '5px'],
}

const index = computed(() => {
    if (phone.value) return 2
    if (mobile.value) return 1
    return 0
})

const height = computed(() => {
    if (page.value) return sizes.page[index.value]
    if (large.value) return sizes.large[index.value]
    if (small.value) return sizes.small[index.value]
    if (xsmall.value) return sizes.xsmall[index.value]
    return sizes.default[index.value]
})

const style = computed(() => (vertical.value ? { width: height.value } : { height: height.value }))
</script>
